<template>
  <div class="flex items-center">
    <icon-base class="mr-1" height="24" width="24" :icon="docType.icon" />
    <span class="mt-1">{{ docType.title }}</span>
  </div>
</template>

<script>
import { computed } from "vue";

import IconPdfSmall from "@/components/icons/fileTypes/IconPdfSmall.vue";

// TODO: Probably incomplete - didn't know at the time of writing which file types are supported
const TYPES = {
  "application/pdf": {
    icon: IconPdfSmall,
    title: "PDF File",
  },
};

export default {
  props: {
    modelValue: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const docType = computed(() => {
      return TYPES[props.modelValue];
    });

    return {
      docType,
    };
  },
};
</script>
